/**
 * useClock - Hook pour afficher l'heure en temps reel (HH:MM)
 */
import { useState, useEffect } from 'react';

export function useClock(): string {
  const [time, setTime] = useState(() => formatTime(new Date()));

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(formatTime(new Date()));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return time;
}

function formatTime(date: Date): string {
  return date.toLocaleTimeString('fr-BE', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}
